<template>
  <div class="unity-wrap">
    <!-- 游戏内中文输入法插件匹配ID为unity-container的容器 -->
    <div id="unity-container">
      <VueUnity v-if="isShowUnity" :unity="unityContext" tabindex="-1" id="FPGameCanvas"/>
    </div>
    <!-- Loading界面 -->
    <GameLoading v-if="!isHideLoading" :startGame="startGame" :hideLoading="isHideLoading" @play="isHideLoading = true" :progress="progress" :loading-text="loadingText"></GameLoading>
    <!-- 支付完成弹窗 -->
    <PopupPurchaseComplete v-if="isShowPopup === 'PopupPurchaseComplete'" @close="popupPCClose"></PopupPurchaseComplete>
    <!-- 支付完成弹窗 -->
    <PopupVideoPlayer v-if="isShowVideoPlayer" :hideLoading="isHideLoading" :options="videoOptions" @onVideoEnded="onVideoEnded"></PopupVideoPlayer>
    <!-- Unity指令模拟面板 -->
    <!-- <TestSimulator @unitySendMessage="handleMessage" @jsSendMessage="msg => sendToUnity(msg)" @reload="reloadGame" /> -->
    <!-- 通用弹窗 - 队列展示 -->
    <QueuePopup ref="QueuePopup" v-if="!isGameStart"></QueuePopup>
  </div>
</template>

<script>
import UnityWebgl from 'unity-webgl'
import VueUnity from 'unity-webgl/vue'

import { mapState } from 'vuex'
import { versionConfig } from '@/server/api'
import unityCmdHandler from '@/utils/unityCmdHandler.js'
import indexedDB from '@/utils/indexedDB.js'
// import JSZip from 'jszip'

import { SOCIAL_CODE_KEY_MAP } from '@/enum/const'

import GameLoading from './GameLoading.vue'
import PopupPurchaseComplete from './popup/PurchaseComplete.vue'
import PopupVideoPlayer from './popup/PopupVideoPlayer.vue'
import QueuePopup from './queuePopup/QueuePopup.vue'

// import TestSimulator from '../testSimulator.vue'

export default {
  name: 'WebGameBox',
  components: { GameLoading, VueUnity, PopupPurchaseComplete, PopupVideoPlayer, QueuePopup },
  data () {
    return {
      // 进度条开头的虚拟进度
      progressStartTimer: null,
      // Unity传出的进度
      unityProgress: 0,
      // 转换的进度
      progress: 0,
      popupCpns: ['PopupPurchaseComplete', 'PopupInstallBonus'],
      urlParams: {},
      isFirstLoadingGame: true,
      isHideLoading: false,
      isGameStart: false,
      isShowUnity: process.env.VUE_APP_UNITY_ASSETS_FROM !== 'cdn',
      hideLoadingTimer: null,
      isShowPopup: '',
      isShowInstallBonus: false,
      unityContext: process.env.VUE_APP_UNITY_ASSETS_FROM === 'cdn' ? null : new UnityWebgl({
        loaderUrl: `${process.env.VUE_APP_UNITY_RESOURCES}/${process.env.VUE_APP_UNITY_RESOURCES_KEY}.loader.js`,
        dataUrl: `${process.env.VUE_APP_UNITY_RESOURCES}/${process.env.VUE_APP_UNITY_RESOURCES_KEY}.data`,
        frameworkUrl: `${process.env.VUE_APP_UNITY_RESOURCES}/${process.env.VUE_APP_UNITY_RESOURCES_KEY}.framework.js`,
        codeUrl: `${process.env.VUE_APP_UNITY_RESOURCES}/${process.env.VUE_APP_UNITY_RESOURCES_KEY}.wasm`
      }),
      deviceInfoForSdk: {
        device_type: this.$utils.getDeviceType(),
        // os: this.$utils.getOs(),
        // 钟豪：帮忙把os返回，写死webgl
        os: 'webgl',
        os_version: this.$utils.getOsVersion(),
        time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        device_lang: navigator.language,
        device_id: localStorage.getItem('login-type') === 'account' ? localStorage.getItem('social-did') : localStorage.getItem('local-did'),
        sdk_version: '', // ??
        rom_gb: '',
        ram_mb: '',
        cpu_max_freq_khz: '',
        display_size: `${window.screen.width}x${window.screen.height}`,
        client_ip: ''
      },
      uInitPaymentData: {},
      unityInstanceStatus: 'unload',
      reloadGameTimes: 0,
      isShowVideoPlayer: false,
      videoOptions: {},
      // game assets 下载进度 - 2 无新版本不下载 | 1 准备下载 | 0 - 下载成功 | -1 下载失败
      // https://funplus.yuque.com/sf1r4l/orh4er/cw4wd8bady8g949h#vy8Tf
      gameAssetsStatus: 1,
      gameAssetsFileName: 'GameAssets_WS',
      gameAssetsFiles: [],
      gameAssetsDBInfo: {},
      gameAssetsBlobURL: null,
      // 是否执行过Untity进度异常检查
      unityProgressUnusualCheck: false,
      // Untity进度完成次数（大于1记一次，最后1的时候记一次）
      unityProgressCompletedTimes: 0,
      checkProgressTimer: null,
      // 游戏loading阶段下载进度同步次数，最多两次
      gameLoadingMsgTimes: 0,
      loadingText: ''
    }
  },
  computed: {
    ...mapState({
      loginType: 'loginType',
      userInfo: 'userInfo'
    }),
    startGame () {
      return this.isGameStart && this.loginType !== ''
    }
  },
  watch: {
    startGame (nv) {
      if (nv) {
        this.$utils.consoleLog('watch startGame - isNew: ', this.userInfo.isNew)
        if (this.userInfo.isNew || this.userInfo.isVisitorBind) {
          const socialType = localStorage.getItem('social_login_type')
          const extraParams = {
            account_id: 0,
            is_login: 1,
            player_index: 0
          }
          const datailParams = {
            newuser_type: this.userInfo.loginType === 'guest_login' ? 'guest_login' : SOCIAL_CODE_KEY_MAP[socialType]
          }
          this.$utils.log('web_newuser', datailParams, extraParams)
        }
        if (this.isFirstLoadingGame) {
          this.$bus.$emit('first-load-game-start')
        }
      }
    }
  },
  created () {
    // this.$utils.consoleLog('log pc_page_view')
    // this.$utils.log('pc_page_view', {}, { log_source: 'wp' })
  },
  mounted () {
    // 打点时机调整
    const logParams = {
      type: 'open_page',
      join_method: this.$utils.getPWADisplayMode === 'standalone' ? 'shortcut' : 'website'
    }
    this.$utils.log('web_page_view', logParams)
    this.init()
    window.addEventListener('beforeunload', this.onBeforeUnload, false)
  },
  methods: {
    init () {
      window.loading_bar_status = ''
      if (process.env.VUE_APP_UNITY_ASSETS_FROM === 'cdn') {
        this.getUnityAssetsBaseUrl()
      } else {
        this.initListener()
      }
      this.urlParams = this.$utils.getParamsFromUrl({ notLocal: true })
      // 接收登录成功消息
      this.$bus.$on('loginComplete', () => {
        this.$nextTick(() => {
          this.reloadGame('bus_loginComplete')
        })
      })
      // 绑定后不重启游戏，通知游戏 cmd - update-account-info
      this.$bus.$on('tell-game-update-account-info', () => {
        this.$nextTick(() => {
          this.sendToUnity({
            cmd: 'update_account_info',
            data: {
              game_device_id: this.$utils.getDeviceId(),
              game_device_uuid: this.$utils.getDeviceUUId(),
              user_info: JSON.stringify({
                code: 0,
                msg: '',
                data: this.userInfo
              })
            }
          })
        })
      })
      this.$bus.$on('reloadGame', () => {
        this.reloadGame('bus_reloadGame')
      })
      // 静音控制
      this.$bus.$on('mute-control', status => {
        this.muteControl(status)
      })
    },
    getUnityAssetsBaseUrl () {
      this.$utils.consoleLog('versionConfig')
      versionConfig()
        .then(res => {
          const { webgame } = res
          this.isShowUnity = true
          const gameAssetsUrlDir = `${webgame.url}/StreamingAssets`
          const gameAssetsUrl = `${gameAssetsUrlDir}/${this.gameAssetsFileName}.zip`
          const ext = webgame.ext || {}
          this.unityContext = new UnityWebgl({
            loaderUrl: `${webgame.url}/Build/${process.env.VUE_APP_UNITY_RESOURCES_KEY}.loader.js`,
            dataUrl: `${webgame.url}/Build/${process.env.VUE_APP_UNITY_RESOURCES_KEY}.data.${ext.format || 'gz'}`,
            frameworkUrl: `${webgame.url}/Build/${process.env.VUE_APP_UNITY_RESOURCES_KEY}.framework.js.${ext.format || 'gz'}`,
            codeUrl: `${webgame.url}/Build/${process.env.VUE_APP_UNITY_RESOURCES_KEY}.wasm.${ext.format || 'gz'}`,
            streamingAssetsUrl: gameAssetsUrlDir
          })
          this.initListener()
          // 判断版本
          if (webgame.md5 !== localStorage.getItem('game_assets_md5')) {
            this.fetchGameAssets(gameAssetsUrl, webgame.md5)
          } else {
            // 无新版本
            this.gameAssetsStatus = 2
          }
          window.progressStartSign = new Date().getTime()
          this.$utils.consoleLog('Pregress - set progressStartSign', window.progressStartSign)
          this.progressStartTimer = setInterval(() => {
            if (this.progress >= 0.69) {
              this.progressStartTimer && clearInterval(this.progressStartTimer)
              this.progressStartTimer = null
              return
            }
            this.progress += 0.0023
          }, 100)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 监听Unity事件
    initListener () {
      const _this = this
      this.unityContext
        .on('created', function () {
          _this.unityInstanceStatus = 'created'
          _this.$utils.consoleLog('unityContext created')
          // game 实例对象，sdk 内部使用到这个name，初始化后需要赋值
          window.FPXGameInstance = this.unityInstance
          // 添加canvas click事件监听，解决WebGL收集全局输入事件
          document.addEventListener('click', function (e) {
            window.hasCustomClicked = true
            const on = Number(e.target.id === 'FPGameCanvas')
            // 点击位置不同再通知切换 WebGL收集全局输入事件
            if (window.UNITY_FOCUS !== on) {
              // 记录上次点击位置
              window.UNITY_FOCUS = on
              _this.sendToUnity({
                cmd: 'focus_canvas',
                data: {
                  on
                }
              })
            }
          })
        })
      window.loading_bar_status = 'web_loading_start'
      this.$utils.log('web_loading_start')
      // 开始加载，时间标记
      this.logParamTimeSign = new Date().getTime()
      // 判断【开始加载】或上一次加载未完成【重新加载】
      localStorage.setItem('log_param_loading_status', 'loading')
      /**
       * * 进度条分段
       * @progress (0~69) 虚拟进度，最长总用时30s（如果真实进度 > 69则清空定时器，显示真实进度）
       * @progress (0~70) Unity传出的真实进度如果大于60显示真实进度
       * @progress (70~80) 虚拟进度，约10s，检查Unity进度是否大于1
       * @progress (80~99) 虚拟进度，约10s（如果接收到进入游戏的消息，立刻到100，进入游戏）
       * @progress (99~100) 等待进入游戏的消息
       */
      this.unityContext
        .on('progress', function (num) {
          _this.unityProgress = num
          // 标记 - ‘progress’：传出真是进度的情况 | ‘no-progress’：进度值只有0-0.9-1的情况
          const sign = 'no-progress'
          // let sign = 'no-progress'
          // if (num !== 0) {
          //   sign = 'progress'
          //   _this.progressStartTimer && clearInterval(_this.progressStartTimer)
          //   _this.progressStartTimer = null
          // }
          const transNum = num * 0.7
          if (transNum <= 0.69 && sign === 'no-progress') {
          } else if (num === 1) {
            _this.progress = 0.8
            // 更新loading文案
            _this.loadingText = _this.$t('text_loading_requestion')
            _this.checkProgressTimer && clearInterval(_this.checkProgressTimer)
            _this.checkProgressTimer = null
          } else if (num >= 1) {
            if (!_this.unityProgressUnusualCheck) {
              _this.progress = 0.70
              _this.loadingText = _this.$t('text_loading_extracting')
              _this.unityProgressUnusualCheck = true
              _this.unityProgressCompletedTimes++
              // _this.playProgressAnimAndCheck()
              _this.checkProgressTimer = setInterval(() => {
                _this.progress = _this.progress >= 0.799 ? 0.799 : _this.progress + 0.001
              }, 100)
            }
          } else {
            if (_this.progressStartTimer !== null) {
              _this.progressStartTimer && clearInterval(_this.progressStartTimer)
              _this.progressStartTimer = null
            }
            _this.progress = transNum
          }
          _this.$utils.consoleLog('progress: ', num)
        })
      this.unityContext
        .on('destroyed', () => {
          _this.unityInstanceStatus = 'destroyed'
          _this.$utils.consoleLog('unityContext on destroyed')
        })
      window.FPX_UnitySendMessage = (msg) => this.handleMessage(msg)
      // window.FPX_UnitySendMessage('{"cmd":"play_video","data":{"method":"playVideo","parameters":{"videoName":"cg_beginning_new","url":"https://ss-global-cdn.akamaized.net/assets/video/2022-03-03/dbe38e157f482f9954204a2008badd71/chunk/playlist.m3u8","autoClose":"1","closeEnable":"1"}}}')
      // unread Faq
      // this.handleMessage('{"cmd":"open_faq","data":{"configJson":{"userInfo":{"gameId":"30001","serverId":"1","fpid":"301902147041427","uid":"400000868","pkgChannel":"ss_funplus_web","lang":"zh-CN","gameToken":"eyJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjQwMDAwMDg2OCwiZnBpZCI6MzAxOTAyMTQ3MDQxNDI3LCJraWQiOjEsImNfa2lkIjoxLCJ0aW1lIjoxNjc3MDQ3NjcxLCJsb2dpbl90aW1lIjoxNjc3MDQ3NjcxLCJkZXZpY2VfaWQiOiI5NDY1QUY2NzkzNkQ0YTAxQUZEMkE4QjFDNUJBRTBERCIsInNlc3Npb25fa2V5IjoiVlJmREZWSTB0VzJCcVJ3cTZ6dUh3RDFuSkJiVDh5YVZxcGxNblU4enltWXRyYzU0In0.5e-vBM6ohbqn1SE7tEYygdp41p1QIIzV5vstwpmRstk","name":"Dev.191346"},"baseUrl":"http://ss-faq.funplus.com","baseUrlV2":"https://sscs-web-stage.funplus.com","ticketsBaseUrl":"https://fpcs-web-stage.funplus.com","isFaqV2":1,"cutoutWidth":0,"appId":"8GyET0HD3cClqNmK","secretKey":"Qw4rUcnk6vJ3ZGWbIXRC"},"messageJson":{"method":"requestUnreadMessage","parameters":{"scene":"0","device_id":"9465AF67936D4a01AFD2A8B1C5BAE0DD","fpid":"301902147041427","uid":"400000868","json_data":""}}}}')
    },
    /**
     * 进度70%~80%
     */
    playProgressAnimAndCheck () {
      this.checkProgressTimer = setInterval(() => {
        // 进度异常情况，Unity进度完成过2次 或进度值大于200%时：进度到达80%，进入模拟增加进度，等待游戏通知
        if (this.unityProgressCompletedTimes >= 2 || this.unityProgress >= 2) {
          this.$utils.consoleLog('进度异常，进度值到达0.8')
          this.progress = 0.8
          this.checkProgressTimer && clearInterval(this.checkProgressTimer)
          this.checkProgressTimer = null
          return
        }
        // 进度正常情况
        if (this.progress >= 0.799 && this.unityProgress <= 1) {
          this.$utils.consoleLog('进度正常，进度值到达0.8')
          this.progress = 0.8
          // loading文案
          this.loadingText = this.$t('text_loading_requestion')
          this.checkProgressTimer && clearInterval(this.checkProgressTimer)
          this.checkProgressTimer = null
          return
        }
        this.progress = this.progress >= 0.799 ? 0.799 : this.progress + 0.001
      }, 100)
    },
    /**
     * 进度80%~99.99%
     * 游戏会分成两次提供loading中下载进度信息，最少一次最多两次
     */
    gameLoadingProgress (data) {
      if (data.read_files >= data.total_files) {
        this.gameLoadingMsgTimes++
      }
      this.$utils.consoleLog('game_download_progress - gameLoadingMsgTimes', this.gameLoadingMsgTimes)
      const initProgress = (this.gameLoadingMsgTimes <= 2 ? this.gameLoadingMsgTimes : 2) * 0.1
      let gameDlProgress = data.total_size ? ((data.read_size / data.total_size) * 0.1) : 0
      if (data.read_files === data.total_files) {
        gameDlProgress = 0
      }
      const calcProgress = (0.8 + initProgress + gameDlProgress) >= 1 ? 0.999 : (0.8 + initProgress + gameDlProgress)
      this.progress = calcProgress > this.progress ? calcProgress : this.progress
      // this.$utils.consoleLog('game_download_progress - progress', `${initProgress} | ${gameDlProgress}`)
      this.$utils.consoleLog('game_download_progress - progress', this.progress)
      this.loadingText = `${this.$t('lSimulatorLoading')}${data.total_size > 0 ? `(${(data.read_size / 1024 / 1024).toFixed(2)}M/${(data.total_size / 1024 / 1024).toFixed(2)}M)` : ''}`
      if (data.read_files === data.total_files) {
        this.loadingText = this.$t('text_loading_requestion')
      }
      if (this.progress >= 0.999) {
        this.loadingText = this.$t('text_loading_extracting')
      }
    },
    /**
     * 发送消息到Unity
     * @param {string} objectName Unity scene name.
     * @param {string} methodName public method name.
     * @param {any} params an optional method parameter.
     */
    sendToUnity (msg) {
      const message = {
        flag: 'fp-web-game',
        ...msg
      }
      this.unityContext.send('KGSimulatorWebGLCaller', 'OnCallback', JSON.stringify(message))
      this.$utils.consoleLog('send to Unity: ', JSON.stringify(message))
    },
    // 处理消息
    handleMessage (msg) {
      this.$utils.consoleLog('message from Untiy: ', msg)
      let sdkMessage = {}
      try {
        sdkMessage = JSON.parse(msg)
      } catch (error) {
        console.log('==z==> Err: ', error)
      }
      if (sdkMessage.cmd) {
        // SDK发出 消息通道初始化完成
        if (sdkMessage.cmd === 'appStarted') {
          this.$bus.$emit('message-channel-is-ready')
          // 本地存储的静音状态同步给游戏
          const muteStatus = localStorage.getItem('mute-control') === 'off' ? 0 : 1
          this.muteControl(muteStatus)
        }
        // 游戏启动成功，可以进游戏
        if (sdkMessage.cmd === 'game_ready_to_play') {
          window.progressDownSign = 1
          this.progress = 1
          this.isGameStart = true
          this.isFirstLoadingGame = false
          this.$refs.popupAntiLoss && this.$refs.popupAntiLoss.handleClose()
          const duration = parseInt((new Date().getTime() - this.logParamTimeSign) / 1000)
          if (localStorage.getItem('log_param_loading_status') !== 'complete') {
            window.loading_bar_status = 'web_loading_finish'
            this.$utils.log('web_loading_finish', { loading_duration: duration })
          }
          localStorage.setItem('log_param_loading_status', 'complete')
        } else if (sdkMessage.cmd === 'ask_account_info') {
          // 发送device信息给Unity
          this.sendToUnity({
            cmd: 'ask_account_info',
            data: {
              game_device_id: this.$utils.getDeviceId(),
              game_device_uuid: this.$utils.getDeviceUUId()
            }
          })
          this.afterGameLogin()
          // BI 字段
          this.sendToUnity({
            cmd: 'get_device_info',
            data: { ...this.deviceInfoForSdk }
          })
        } else if (sdkMessage.cmd === 'get_device_info') {
          // BI 字段
          this.sendToUnity({
            cmd: 'get_device_info',
            data: { ...this.deviceInfoForSdk }
          })
        } else if (sdkMessage.cmd === 'open_in_browser') {
          // 打开URL
          this.$utils.openBrowser(sdkMessage.data.url)
        // } else if (sdkMessage.cmd === 'update_user_info') {
        } else if (sdkMessage.cmd === 'init_payment') {
          // 初始化充值环境，接收gameinfo
          this.uInitPaymentData = { ...sdkMessage.data }
          this.getProducts()
          // 如果是新用户再次请求openid
          if (this.userInfo.isNew || !this.userInfo.openid) {
            const _this = this
            const timer = setTimeout(() => {
              _this.$bus.$emit('new-user-get-openid', this.userInfo.fpid)
              clearTimeout(timer)
            }, 5000)
          }
        } else if (sdkMessage.cmd === 'open_pay') {
          // 打开支付
          unityCmdHandler.openPay({ ...this.uInitPaymentData, ...sdkMessage.data })
          this.isShowPopup = 'PopupPurchaseComplete'
        } else if (sdkMessage.cmd === 'update_user_info') {
          // 更新用户信息
        } else if (sdkMessage.cmd === 'refresh_device_uuid') {
          // 当游戏中deviceUUID刷新时通知web
          unityCmdHandler.refreshDeviceUuid(sdkMessage.device_uuid)
        } else if (sdkMessage.cmd === 'open_faq') {
          const messageJson = sdkMessage.data.messageJson
          const method = (messageJson && messageJson.method) || ''
          if (method === 'requestUnreadMessage') {
            // 获取faq未读取消息
            this.getFaqUnread(sdkMessage.data)
          } else if (method === 'openFAQ') {
            // 打开智能客服 FAQ
            unityCmdHandler.openFaq(sdkMessage.data)
          } else if (method === 'openTickets') {
            // 打开Tickets
            unityCmdHandler.openTickets(sdkMessage.data)
          }
        } else if (sdkMessage.cmd === 'init_community') {
          // 初始化社区
          this.initCommunity(sdkMessage.data)
        } else if (sdkMessage.cmd === 'open_community') {
          // 打开社区
          unityCmdHandler.openCommunity(sdkMessage.data)
        } else if (sdkMessage.cmd === 'tell_game_level') {
          // 要塞升级
          this.$utils.consoleLog('bus emit open-install-bonus-popup')
          this.$bus.$emit('open-install-bonus-popup', sdkMessage.data)
        } else if (sdkMessage.cmd === 'tell_game_crashed') {
          unityCmdHandler.sendGameCrashedLog(sdkMessage.data)
        } else if (sdkMessage.cmd === 'delete_indexed_db') {
          this.delIndexedDB(sdkMessage.data)
        } else if (sdkMessage.cmd === 'play_video') {
          // 播放CG
          if (sdkMessage.data.method === 'playVideo') {
            this.isShowVideoPlayer = true
            this.videoOptions = { ...sdkMessage.data.parameters }
          }
        } else if (sdkMessage.cmd === 'copy_to_clipboard') {
          // 复制内容到剪贴板
          this.$utils.copyToClipboard(sdkMessage.data.text)
        } else if (sdkMessage.cmd === 'game_need_to_unzip') {
          // 缓存游戏indexDB库表信息
          // this.gameAssetsDBInfo = { ...sdkMessage.data }
          // 标记已接收到游戏信息，web直接返回zip包ObjectURL
          this.gameAssetsDBInfo = { dbname: '123' }
          // 如果下载完成，执行存储文件
          if (this.gameAssetsStatus === 0) this.putFilesInDB('cmd')
          if (this.gameAssetsStatus === 2) {
            this.sendToUnity({
              cmd: 'game_need_to_unzip',
              data: {
                result: -1
              }
            })
          }
        } else if (sdkMessage.cmd === 'game_download_progress') {
          this.gameLoadingProgress(sdkMessage.data)
        }
      }
    },
    reloadGame (from) {
      this.$utils.consoleLog('reloadGam - from: ' + from + ' - reloadGameTimes: ' + this.reloadGameTimes)
      if (this.reloadGameTimes === 0) {
        this.reloadGameTimes++
        return
      }
      this.sendToUnity({
        cmd: 'restart_game',
        data: {}
      })
    },
    afterGameLogin () {
      // ...
    },
    // 初始化社区入口
    async initCommunity (data) {
      try {
        data = typeof data === 'string' ? JSON.parse(data) : data
      } catch (error) {}
      const productData = {
        cmd: 'init_community',
        data: {}
      }
      productData.data = await unityCmdHandler.initCommunity(data)
      this.sendToUnity(productData)
    },
    async getProducts () {
      // 获取商品列表
      const productData = {
        cmd: 'get_iapProducts',
        data: {
          errorCode: 0,
          errorMessage: 'FunPlusPlay: products init success',
          products: []
        }
      }
      productData.data.products = await unityCmdHandler.getProductData()
      this.sendToUnity(productData)
    },
    async getFaqUnread (data) {
      // 获取faq未读取消息
      const productData = {
        cmd: 'requestUnreadMessage',
        data: {}
      }
      productData.data = await unityCmdHandler.getFaqMsgNumber(data)
      this.sendToUnity(productData)
    },
    async delIndexedDB (data) {
      // 删除数据库 key
      const productData = {
        cmd: 'delete_indexed_db',
        data: {}
      }
      try {
        await indexedDB.deleteByKey(data)
        productData.data.result = 0
      } catch (err) {
        productData.data.result = 1
      }
      this.sendToUnity(productData)
    },
    // 支付完成弹窗关闭
    popupPCClose () {
      this.isShowPopup = ''
      this.sendToUnity({
        cmd: 'open_pay',
        data: {
          errorCode: 10006,
          errorMessage: '[FPIAP|pay] purchase finish'
        }
      })
    },
    // CG视频播放完毕
    onVideoEnded () {
      this.isShowVideoPlayer = false
      this.sendToUnity({
        cmd: 'video_ended',
        data: {
          type: '',
          parameters: {
            reason: 0,
            videoname: '',
            error: {
              code: 0,
              message: ''
            }
          }
        }
      })
    },
    // 获取游戏必要资源提前下载
    async fetchGameAssets (assetsUrl, md5) {
      try {
        const response = await fetch(assetsUrl, { responseType: 'blob' })
        localStorage.setItem('game_assets_md5', md5)
        this.$utils.consoleLog('fetchGameAssets completed')
        try {
          const blob = await response.blob()
          this.gameAssetsBlobURL = URL.createObjectURL(blob)
          this.$utils.consoleLog('fetchGameAssets createObjectURL')
          this.gameAssetsStatus = 0
          // const zip = new JSZip()
          // const files = await zip.loadAsync(blob)
          // this.$utils.consoleLog('fetchGameAssets unzip: ', files)
          // this.gameAssetsFiles = Object.keys(files.files)
          // window.gameAssetsFiles = files
          // 如果已经收到Unity消息，执行存储文件
          if (this.gameAssetsDBInfo.dbname) this.putFilesInDB('fetch')
        } catch (error) {
        }
      } catch (error) {
        this.sendToUnity({
          cmd: 'game_need_to_unzip',
          data: {
            result: -1
          }
        })
      }
    },
    async putFilesInDB (from) {
      this.$utils.consoleLog('func: putFilesInDB - from: ', from)
      this.sendToUnity({
        cmd: 'game_need_to_unzip',
        data: {
          result: this.gameAssetsBlobURL ? 0 : -1,
          url: this.gameAssetsBlobURL
        }
      })
      // try {
      //   const files = window.gameAssetsFiles
      //   const dbName = localStorage.getItem('indexDB_test_dbname') ? 'SSWebAssets' : this.gameAssetsDBInfo.dbname
      //   const tableName = this.gameAssetsDBInfo.tablename
      //   this.$utils.consoleLog('fetchGameAssets 开始遍历文件')
      //   for (const [filename, file] of Object.entries(files.files)) {
      //     const reFileName = this.gameAssetsDBInfo.key + '/' + filename
      //     this.$utils.consoleLog('fetchGameAssets - foreach - ', reFileName, file)
      //     const fileData = new Uint8Array(await files.files[filename].async('uint8array'))
      //     await indexedDB.putFile(dbName, tableName, reFileName, fileData)
      //   }
      //   this.$utils.consoleLog('fetchGameAssets 写入文件完成')
      //   window.gameAssetsFiles = null
      //   // this.sendToUnity({
      //   //   cmd: 'game_need_to_unzip',
      //   //   data: {
      //   //     result: 0
      //   //   }
      //   // })
      // } catch (error) {
      //   this.sendToUnity({
      //     cmd: 'game_need_to_unzip',
      //     data: {
      //       result: -1
      //     }
      //   })
      // }
    },
    // 静音控制 - status: 0 Closed | 1 Open
    muteControl (status) {
      this.$utils.consoleLog('muteControl', status)
      this.sendToUnity({
        cmd: 'set_game_voice',
        data: {
          open: status
        }
      })
    },
    onBeforeUnload () {
      this.$utils.log('loading_window_close', { loading_step_name: window.loading_bar_status })
    }
  },
  destroyed () {
    window.removeEventListener('beforeunload', this.onBeforeUnload, false)
  }
}
</script>

<style lang='scss' scoped >
.unity-wrap {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #000;
  #unity-container{
    width: 100%;
    height: 100%;
  }
}
</style>
